import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithEmailAndPassword,
  confirmPasswordReset,
  sendPasswordResetEmail,
  signOut
} from 'firebase/auth';
import { firebaseConfig } from '../config/firebase';

initializeApp(firebaseConfig);

const auth = getAuth();

async function confirmNewPassword(email, code, newPassword) {
  await confirmPasswordReset(auth, code, newPassword);
}

async function forgotPassword(email) {
  try {
    await sendPasswordResetEmail(auth, email);
  } catch (error) {
    throw new Error(error);
  }
}

async function isLoggedIn() {
  return auth;
}

async function login(email, password) {
  try {
    const userCredentials = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    return userCredentials.user;
  } catch (error) {
    const errorCode = error.code;
    const errorMessage = error.message;
    console.log(errorMessage);
    if (errorCode === 'auth/wrong-password') {
      throw new Error('Por favor verifica tu email y contraseña');
    } else {
      throw new Error('Por favor verifica tu email y contraseña');
    }
  }
}

async function logout() {
  await signOut(auth);
}

async function resendConfirm(email) {
  sendPasswordResetEmail(auth, email);
}

function getToken() {
  const user = auth.currentUser;
  return user.getIdToken();
}

export default {
  confirmNewPassword,
  forgotPassword,
  isLoggedIn,
  login,
  logout,
  resendConfirm,
  getToken
};
